import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SharedLanguage, SharedVerificationBanner } from "@/components/shared";
import { getCookie, setCookie } from "@/shared/utils/cookie-helpers";

import { SvgAttribute } from "@/shared/constants/constants";
import { UserInfoResponse } from "@/shared/repository/modules/user/repo";
import { RoutesName } from "@/shared/constants/enums";
import { WalletTotalBalanceResponse } from "@/shared/repository/modules/wallet/repo";
// import { AdminCurrencyType } from "@/shared/repository/modules/admin/currency/enums";
// import {  WalletTotalBalanceResponseFactory } from "@/shared/repository/modules/wallet/factory";
import {
  formatFiatCurrency,
  formatCryptoCurrency,
} from "@/shared/utils/amount-helpers";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedLanguage,
    SharedVerificationBanner,
  },
  data() {
    return {
      isLoading: false,
      userRepo: this.$projectServices.userRepo,
      walletRepo: this.$projectServices.walletRepo,
      authRepository: this.$projectServices.authRepository,
      isFiatVisible: false,
      isCryptoVisible: false,
      view: "light",
      abortController: <AbortController | undefined>undefined,
      timer: 0,
    };
  },
  created(): void {
    this.getBalance();
    this.timer = setInterval(() => {
      this.getBalance();
    }, 60 * 1000);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  computed: {
    displayedFiatActiveClass(): string {
      return this.isFiatVisible
        ? `${COMPONENT_NAME}__toggle--${this.view}-active`
        : "";
    },

    displayedCryptoActiveClass(): string {
      return this.isCryptoVisible
        ? `${COMPONENT_NAME}__toggle--${this.view}-active`
        : "";
    },

    displayedFiatCurrensies(): string[] {
      return this.walletRepo.balance.fiatCurrencys;
    },

    displayedCryptoCurrensies(): string[] {
      return this.walletRepo.balance.cryptoCurrencys;
    },

    displayedCurrency(): WalletTotalBalanceResponse {
      return this.walletRepo.balance;
    },

    displayedFiatAmount(): string {
      return formatFiatCurrency(Object.values(this.walletRepo.balance.fiat)[0]);
    },

    displayedFiatCurrency(): string {
      return Object.keys(this.walletRepo.balance.fiat)[0];
    },

    displayedCryptoAmount(): string {
      return formatCryptoCurrency(
        Object.values(this.walletRepo.balance.crypto)[0]
      );
    },

    displayedCryptoCurrency(): string {
      return Object.keys(this.walletRepo.balance.crypto)[0];
    },

    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedUserInfo(): UserInfoResponse {
      return this.userRepo.userInfo;
    },

    isLogoutDisabled(): boolean {
      return this.isLoading;
    },

    isVerified(): boolean {
      return this.userRepo.isVerified;
    },
  },
  methods: {
    async handleLogout(): Promise<void> {
      this.isLoading = true;
      try {
        await this.authRepository.logout();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
        this.$router.push({ name: RoutesName.login });
      }
    },

    handleFiatToggle(): void {
      this.isFiatVisible = !this.isFiatVisible;
    },

    handleFiatHide(): void {
      this.isFiatVisible = false;
    },

    handleCryptoToggle(): void {
      this.isCryptoVisible = !this.isCryptoVisible;
    },

    handleCryptoHide(): void {
      this.isCryptoVisible = false;
    },

    async handleFiatOption(currency: string): Promise<void> {
      if (!this.userRepo.userInfo.user_info.user_agreement) return;
      setCookie("balance_fiat_currency", currency);
      await this.walletRepo.wallet({
        fiat: currency,
        crypto: this.displayedCryptoCurrency,
      });
      this.isFiatVisible = false;
    },

    async handleCryptoOption(currency: string): Promise<void> {
      if (!this.userRepo.userInfo.user_info.user_agreement) return;
      setCookie("balance_crypto_currency", currency);
      await this.walletRepo.wallet({
        fiat: this.displayedFiatCurrency,
        crypto: currency,
      });
      this.isCryptoVisible = false;
    },

    getBalance(): void {
      const baseFiat = getCookie("balance_fiat_currency") || "USD";
      const baseCrypto = getCookie("balance_crypto_currency") || "USDT";
      this.walletRepo.wallet({ fiat: baseFiat, crypto: baseCrypto });
    },
  },
});
